import { render, staticRenderFns } from "./DuplicateAssessments.vue?vue&type=template&id=7f960cba"
import script from "./DuplicateAssessments.vue?vue&type=script&lang=js"
export * from "./DuplicateAssessments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports